import { IStructFireBase, iStructValidator } from "./../../../interfaces/shared/struct-firebase.interface";
import { Component, Input } from "@angular/core";
import { FormControl } from "@angular/forms";

@Component({
    selector: "app-formulario-dinamico",
    templateUrl: "./formulario-dinamico.component.html",
    styleUrls: ["./formulario-dinamico.component.scss"],
    standalone: false
})
export class FormularioDinamicoComponent {
  @Input() formControlador!: FormControl;
  @Input() set structFireBase(value: IStructFireBase) {
    this.structInput = value;
    if (value.validators) {
      this.setValidators(value.validators);
    }
  }
  @Input() offLabel: boolean = false;
  @Input() offTextData: boolean = false;

  structInput: IStructFireBase;
  validators = {
    min: null,
    max: null,
    maxlength: null,
    minlength: null,
  };

  constructor() { }

  setValidators(validators: Array<iStructValidator>) {
    validators.forEach((validador) => {
      console.log(this.validators);

      const typeValidator = validador.type.toLowerCase();

      switch (typeValidator) {
        case "min":
          this.validators.min = validador.value;
          break;
        case "max":
          this.validators.max = validador.value;
          break;
        case "maxlength":
          this.validators.maxlength = validador.value;
          break;
        case "minlength":
          this.validators.minlength = validador.value;
          break;
      }
    });
  }
}
